import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  selectedSchool: cacheLs.get_school()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
